<template>
  <a-drawer
    placement="right"
    :visible="visible"
    :closable="true"
    :mask-closable="false"
    width="800"
    wrap-class-name="inquiry-filter-drawer"
    @close="onClose"
  >
    <h2
      slot="title"
      class="title clearfix"
    >
      {{ id ? $t('message["1923"]') : $t('message["1914"]') }}
    </h2>
    <a-form
      :form="form"
      :class="{'en-form': $isEnglish}"
    >
      <!-- <a-form-item
        label="视图名称"
      >
        <a-input
          v-decorator="[`name`, {
            validateTrigger: ['change', 'blur'],
            rules: [{
              required: true,
              message: '请输入视图名称'
            }],
            initialValue: name
          }]"
          :max-length="20"
          placeholder="请输入"
        />
      </a-form-item> -->
      <max-length-input
        :value="name"
        :required="true"
        :max="40"
        :label="$t('message[1916]')"
        fieldkey="name"
        :placeholder="`${$t('message[1904]')}${$t('message[1916]')}`"
        @change="handleInputName"
      />
      <filter-item
        v-for="(item) in newData"
        :key="item.fileldkey"
        class="clearfix"
        :data="item"
        @change="onChangeItem"
      />
    </a-form>
    <div class="footer">
      <a-button
        type="primary"
        @click="handleOk"
      >
        {{ $t('message["915"]') }}
      </a-button>
      <a-button
        :style="{marginRight: '8px'}"
        @click="handleCancel"
      >
        {{ $t('message["896"]') }}
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import FilterItem from '@/pc/inquery/filterItem/FilterItem'
import MaxLengthInput from '@/components/pc/MaxLengthInput2'

export default {
  name: 'ViewDetail',
  components: {
    FilterItem,
    MaxLengthInput
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [Number, String],
      default: null
    },
    viewName: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    },
    role: {
      type: [Number, String],
      default: ''
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      name: '',
      config: {},
      newData: []
    }
  },
  computed: {
    ...mapState('config/listview', ['queryData'])
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.getQueryData()
          if (this.id) {
            this.name = this.viewName
          } else {
            this.name = ''
          }
        }
      },
      immediate: true
    },
    queryData: {
      handler (val) {
        if (val) {
          this.newData = _.cloneDeep(val)
          this.resetNewData()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$bus.$on('getQuery', this.getQueryData)
  },
  beforeDestroy () {
    this.$bus.$off('getQuery', this.getQueryData)
  },
  methods: {
    ...mapActions('config/listview', ['getQuery', 'createView', 'editView']),

    async getQueryData () {
      await this.getQuery({
        viewid: this.id,
        page: this.page,
        role: this.role
      })
    },
    resetNewData () {
      this.newData.forEach((item = {}) => {
        const { fieldtype, fieldvalue } = item
        if (!fieldvalue) {
          item.fieldvalue = null
        }
        if (fieldtype === 'datetime' || fieldtype === 'timezones') {
          // 在时间筛选组件里，用 filtertype 字段来判断是否展示快捷时间选项
          item.filtertype = 'listview'
          item.fieldvalue = fieldvalue || {}
          const { starttime = '', endtime = '', dynamic = undefined } = item.fieldvalue
          item.fieldvalue.starttime = starttime
          item.fieldvalue.endtime = endtime
          item.fieldvalue.dynamic = dynamic
        } else if (fieldtype === 'from_info') {
          item.fieldvalue = fieldvalue || []

          if (item.fieldvalue.length) {
            item.fieldvalue.forEach((one = []) => {
              one.forEach((obj = {}, i) => {
                let { fieldtype } = obj
                if (one.length === 2 && i === 1) {
                  if (fieldtype === 'select') {
                    one.push({
                      id: one[1].fieldvalue
                    })
                  } else if (fieldtype === 'text') {
                    one[1].inputVal = one[1].fieldvalue
                  }
                }
              })
            })
          }
        }
      })
    },
    handleInputName (val) {
      this.name = val
    },
    onChangeItem () {},
    hide () {
      this.$emit('update:visible', false)
    },
    onClose () {
      this.hide()
    },
    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    setConfigData () {
      let obj = {}
      for (let item of this.newData) {
        let one = {}
        one.fieldtype = item.fieldtype
        one.fieldkey = item.fieldkey
        one.fieldvalue = item.fieldvalue
        if (item.fieldtype === 'radioinfo_type') {
          const { fieldconfig = {} } = item || {}
          const { info_sign: infoSign = {} } = fieldconfig
          one.info_sign = infoSign.fieldvalue
        }
        obj[item.fieldkey] = one
      }
      return obj
    },

    setRequestParams (filter) {
      let obj = {}
      for (let fieldkey in filter) {
        const item = filter[fieldkey]
        switch (item.fieldtype) {
          case 'text':
          case 'phone':
          case 'email':
          case 'editor':
          case 'tag':
          case 'ip':
            item.fieldvalue = item.fieldvalue.trim()
            if (item.fieldvalue !== '') {
              obj[fieldkey] = item.fieldvalue
            }
            break
          case 'area':
          case 'select_tree':
            if (item.fieldvalue && Object.keys(item.fieldvalue) && Object.keys(item.fieldvalue).length) {
              obj[fieldkey] = item.fieldvalue
            }
            break
          case 'number':
            if (item.fieldvalue.min || item.fieldvalue.max) {
              obj[fieldkey] = item.fieldvalue
            }
            break
          case 'from_info':
            let { fieldvalue = [] } = item

            let arr = []
            for (let i in fieldvalue) {
              let fields = fieldvalue[i] || []

              let one = []
              let len = fields.length

              for (let i = 0; i < len; i++) {
                let obj = fields[i]
                let { fieldkey, id, fieldtype } = obj
                if (i < 2) {
                  one.push({
                    fieldkey,
                    id,
                    fieldtype
                  })
                  if (i === 1 && one[1].fieldtype === 'text') {
                    one[1].fieldvalue = obj.inputVal
                  }
                } else {
                  if (one[1].fieldtype === 'select') {
                    one[1].fieldvalue = obj.id
                  }
                }
              }
              if (Object.keys(one).length) {
                arr.push(one)
              }
            }
            if (arr.length) {
              obj[fieldkey] = arr
            }
            break
          case 'selectrolegroup':
          case 'selectuser':
            let res = item.fieldvalue || []
            for (let j in res) {
              let one = res[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            if (res.length && (res[res.length - 1].roleid || res[res.length - 1].groupid || res[res.length - 1].userid)) {
              obj[fieldkey] = res
            }
            break
          case 'selectfollowuser':
          case 'selectinputuser':
            let values = item.fieldvalue || {}
            let users = values[fieldkey] || []
            for (let j in users) {
              let one = users[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }

            if (Object.keys(values).length) {
              let valueKey = ''
              if (item.fieldtype === 'selectfollowuser') {
                // 跟进人员
                valueKey = 'follow_userid'
              } else if (item.fieldtype === 'selectinputuser') {
                // 录入人员
                valueKey = 'input_userid'
              }
              let userLen = values[valueKey].length
              let last = userLen && values[valueKey][userLen - 1]
              if (userLen && !last.roleid && !last.groupid && !last.userid) {
                values[valueKey].splice(userLen - 1, 1)
              }
              if (valueKey === 'follow_userid' && (values['follow_status'].length || values['follow_userid'].length)) {
                obj[fieldkey] = values
              } else if (valueKey === 'input_userid' && (values['is_universal_form'] || values['input_userid'].length)) {
                obj[fieldkey] = values
              }
            }
            break
          case 'radioinfo_type':
            if (item.info_sign && item.info_sign.length) {
              obj['base_info.info_sign'] = item.info_sign
            }

            if (item.fieldvalue && item.fieldvalue.length) {
              obj[fieldkey] = item.fieldvalue
            }
            break
          case 'select':
          case 'radio':
          case 'radioinfo_payfor':
          case 'radioinfo_level':
          case 'radioinfo_followup':
          case 'checkbox':
            if (item.fieldvalue.length) {
              obj[fieldkey] = item.fieldvalue
            }
            break
          case 'select_reception':
            if (item.fieldvalue.length) {
              item.fieldvalue.forEach((one, i) => {
                if (!one || !one.length) {
                  item.fieldvalue.splice(i, 1)
                }
              })
              obj[fieldkey] = item.fieldvalue
            }
            break
          case 'timezones': // 时间区间
          case 'datetime':
          case 'followup_remind_time':
            if (item.fieldvalue.dynamic || item.fieldvalue.starttime !== '') {
              obj[fieldkey] = item.fieldvalue
            } else if (item.fieldkey === 'next_followup_time' && item.fieldvalue.is_dely) {
              obj[fieldkey] = item.fieldvalue
            } else if (item.fieldkey === 'followup_remind_time' && item.fieldvalue.period) {
              obj[fieldkey] = item.fieldvalue
            }
            break
          default:
            obj[fieldkey] = item.fieldvalue
            break
        }
      }
      return obj
    },
    async handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const obj = this.setConfigData()
          this.config = this.setRequestParams(obj)

          let params = {
            config: this.config,
            name: this.name
          }

          let chain = null
          if (this.id) {
            params.viewid = this.id
            chain = await this.editView(params)
          } else {
            params.page = this.page
            params.role = this.role
            chain = await this.createView(params)
          }

          chain.onSuccess(res => {
            this.hide()
            this.form.resetFields()
            this.newData = []
            this.$emit('updateList', {
              page: this.page,
              role: this.role
            })
          })
        } else {
          const domId = document.getElementById('name')
          domId.scrollIntoView()
        }
      })
    },
    handleCancel () {
      this.hide()
      this.form.resetFields()
      this.newData = []
    }
  }
}
</script>

<style scoped lang="scss">

</style>
<style lang="scss">
.inquiry-filter-drawer {
  .ant-drawer-close {
    top: 44px;
    right: 40px;
    .ant-drawer-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 32px;
      color: #ccc;
    }
  }
  .ant-drawer-content-wrapper {
    overflow-y: auto;
  }
  .ant-drawer-content {
    border-bottom: none;
  }
  .ant-drawer-header {
    padding: 32px 40px 40px;
    border-bottom: none;
  }
  .ant-drawer-title h2 {
    font-size: 32px;
    height: 56px;
    line-height: 56px;
    font-weight: 600;
  }
  .ant-drawer-body {
    padding: 0 40px 70px;
  }
  .ant-form-item-label {
    width: 146px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ant-form-item-control-wrapper {
    padding-left: 146px;
  }
  .more-btn {
    margin: 24px 0 0 16px;
    font-size: 14px;
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 783px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: 1px solid $gray4;
  }
}
</style>
